<div>
  <h3 class="verification-title">{{title}}</h3>
  <br>
  <mat-divider></mat-divider>
  <button mat-flat-button class="primary-btn-action" color="primary" (click)="navigateTo(cancelURL)">CLOSE</button>
</div>
